import React from 'react';
import { Container, Grid, Link, Typography } from '@mui/material';
import { LoginClickHandler } from './Login';
const classes = {
    root: {
        flexGrow: 1,
        align: 'center',
        textAlign: 'justify',
    },
    login: {
        marginRight: '0px',
        marginLeft: 'auto',
    },
    registerSteps: {
        border: '1px solid grey',
        padding: '30px',
        backgroundColor: 'white',
    },
};
const Register = () => {
    return (React.createElement("div", { style: classes.root },
        React.createElement(Container, { maxWidth: 'md' },
            React.createElement(Grid, { container: true, direction: 'column', alignItems: 'center' },
                React.createElement(Grid, { item: true, alignItems: 'center' },
                    React.createElement(Typography, { variant: 'h3', align: 'center', color: 'textPrimary', gutterBottom: true }, "Register")),
                React.createElement(Grid, { item: true, alignItems: 'center' },
                    React.createElement(Typography, { variant: 'body1', color: 'textSecondary', paragraph: true, style: { textAlign: 'center', fontWeight: 600 } }, "This is the new release of the Climate4Impact portal."),
                    React.createElement(Typography, { variant: 'body1', color: 'textSecondary', paragraph: true }, "We are extending the portal with new analysis capabilities based on reproducible Jupyter Notebooks, and a collection of climate related software and workflows. Would you like to access the new services and provide us feedback to contribute to their improvement?"),
                    React.createElement("div", { style: classes.registerSteps },
                        React.createElement(Typography, { variant: 'h5', color: 'textSecondary', paragraph: true }, "1. Create an account at one of the supported identity providers"),
                        React.createElement(Typography, { variant: 'subtitle1', color: 'textSecondary', paragraph: true, style: { paddingLeft: 10, paddingBottom: 10 } },
                            "To log in to C4I you need to have an account at one of these 3 identity providers:",
                            ' ',
                            React.createElement(Link, { target: '_blank', rel: 'noopener', href: 'https://accounts.ceda.ac.uk/' }, "CEDA"),
                            ",",
                            ' ',
                            React.createElement(Link, { target: '_blank', rel: 'noopener', href: 'https://github.com/signup' }, "GitHub"),
                            ' ',
                            "or",
                            ' ',
                            React.createElement(Link, { target: '_blank', rel: 'noopener', href: 'https://orcid.org/signin' }, "ORCID"),
                            ". If you already have an account you can use it to log in to C4I via the ESGF",
                            ' ',
                            React.createElement(Link, { component: 'button', variant: 'subtitle1', style: { paddingBottom: '2.5px' }, onClick: LoginClickHandler }, "login page"),
                            ' ',
                            "(Single Sign On)."),
                        React.createElement(Typography, { variant: 'h5', color: 'textSecondary', paragraph: true }, "2. Register for all C4I features"),
                        React.createElement(Typography, { variant: 'body1', color: 'textSecondary', style: { paddingLeft: 10 }, paragraph: true },
                            "Send an email to ",
                            React.createElement("b", null, "c4i(at)knmi.nl"),
                            " from same email address you have used in the previous step. Please, indicate in the text text of the email your affiliation, your role in the organisation and background. Once we have upgraded the account, you will have full access to the portal.")),
                    React.createElement(Typography, { variant: 'body1', color: 'textSecondary', paragraph: true }, "If you are already registered, click the login button."))))));
};
export default Register;
